import type { FC } from 'react'

interface Props {
  href: string
  children?: string
  linkColor?: string
  target?: string
}

const AmSimpleLink: FC<Props> = ({ href, children, linkColor, target }) => (
  <a
    href={href}
    target={target}
    style={{
      textDecoration: 'underline',
      color: linkColor || '#F36159'
    }}
  >
    {children}
  </a>
)

export default AmSimpleLink
